"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Source = void 0;
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const syntax_highlighter_1 = __importDefault(require("../syntax-highlighter"));
class BareSource extends React.Component {
    render() {
        // Build in a default renderer when they pass a plain string
        // This is primarily for use with non-editable contexts (notebook-preview)
        // to make rendering much faster (compared to codemirror)
        // Ref: https://github.com/nteract/notebook-preview/issues/20
        if (typeof this.props.children === "string") {
            return (React.createElement(syntax_highlighter_1.default
            // NOTE: To get around styled-components & defaultProps not lining up,
            // this defaults to "text" for us https://github.com/DefinitelyTyped/DefinitelyTyped/issues/29540
            , { 
                // NOTE: To get around styled-components & defaultProps not lining up,
                // this defaults to "text" for us https://github.com/DefinitelyTyped/DefinitelyTyped/issues/29540
                language: this.props.language || "text", className: this.props.className || "input" }, this.props.children));
        }
        // Otherwise assume they have their own editor component
        return React.createElement("div", { className: this.props.className }, this.props.children);
    }
}
BareSource.defaultProps = {
    children: "",
    language: "text",
    className: "input",
    theme: "light"
};
exports.Source = styled_components_1.default(BareSource) `
  width: 100%;
  width: -webkit-fill-available;
  width: -moz-available;
`;
exports.Source.defaultProps = {
    children: "",
    language: "text",
    className: "input",
    theme: "light"
};
exports.Source.displayName = "Source";
exports.default = exports.Source;
//# sourceMappingURL=source.js.map